<div class="spinner-wrapper">
    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  </div>